import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  ColorGenerator,
} from "@shortsworks/ui";
import { cn } from "@shortsworks/ui/lib/utils";
import { FormItemProps } from "@app/components/forms/types/props";
import { ColorSelectorSchema } from "@app/components/forms/types/schema";

// setFormValues 적용 시 컬러 픽커가 변경되지 않는 점 확인
export const FormColor = ({
  form,
  schema,
  ...rest
}: FormItemProps<ColorSelectorSchema>) => {
  return (
    <FormField
      control={form.control}
      name={schema.id}
      render={({ field }: any) => (
        <FormItem
          className={cn(
            schema.appearance?.className,
            schema.appearance?.border ? "border p-3 rounded-lg shadow-sm" : "",
            schema.behavior?.hidden && "hidden",
          )}
        >
          <FormLabel>
            {typeof schema.label === "function"
              ? schema.label(form.getValues())
              : schema.label}
          </FormLabel>
          {schema.description && (
            <FormDescription>
              {typeof schema.description === "function"
                ? schema.description(form.getValues())
                : schema.description}
            </FormDescription>
          )}
          <FormControl>
            {/*<Input placeholder={schema.placeholder} {...field} {...schema.behavior} />*/}
            <div
              className={cn(schema.extraContent && "grid grid-cols-2 gap-4")}
            >
              <ColorGenerator
                defaultValue={form.getValues()[schema.id]}
                onChange={field.onChange}
              />
              <div>
                {typeof schema.extraContent === "function"
                  ? schema.extraContent(form.getValues())
                  : schema.extraContent}
              </div>
            </div>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
